var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.header)?_c('PartnershipNavbar',{attrs:{"slice":_vm.header}}):_vm._e(),_vm._v(" "),_vm._l((_vm.slices),function(slice,sliceIndex){return _c(slice.slice_type,{key:sliceIndex,tag:"component",attrs:{"slice":slice}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }